/* Local dependencies */
import { GroupName, IdentificationStatus } from '../../types';

export enum UpdateUserForAdminActionTypes {
  UPDATE_USER_FOR_ADMIN_REQUEST = 'UPDATE_USER_FOR_ADMIN_REQUEST',
  UPDATE_USER_FOR_ADMIN_SUCCESS = 'UPDATE_USER_FOR_ADMIN_SUCCESS',
  UPDATE_USER_FOR_ADMIN_ERROR = 'UPDATE_USER_FOR_ADMIN_ERROR',
  RESET_ERROR = 'RESET_UPDATE_USER_FOR_ADMIN_ERROR',
  UPDATE_USER_FOR_ADMIN_RESET = 'UPDATE_USER_FOR_ADMIN_RESET',
}

export interface UpdateUserForAdminInput {
  id: string;
  groupName?: GroupName;
  identificationStatus?: IdentificationStatus;
}

export interface UpdateUserForAdminRequest {
  type: UpdateUserForAdminActionTypes.UPDATE_USER_FOR_ADMIN_REQUEST;
  input: UpdateUserForAdminInput;
}

export interface UpdateUserForAdminSuccess {
  type: UpdateUserForAdminActionTypes.UPDATE_USER_FOR_ADMIN_SUCCESS;
}

export interface UpdateUserForAdminError {
  type: UpdateUserForAdminActionTypes.UPDATE_USER_FOR_ADMIN_ERROR;
  error: Error;
}

export interface ResetUpdateUserForAdminError {
  type: UpdateUserForAdminActionTypes.RESET_ERROR;
}

export interface UpdateUserForAdminReset {
  type: UpdateUserForAdminActionTypes.UPDATE_USER_FOR_ADMIN_RESET;
}

export type UpdateUserForAdminAction =
  | UpdateUserForAdminRequest
  | UpdateUserForAdminSuccess
  | UpdateUserForAdminError
  | ResetUpdateUserForAdminError
  | UpdateUserForAdminReset;
